<template>
    <div class="template-login-register">
        <header class="header-animation">
            <div class="top">
                <div class="container">
                    <a href="https://simoniot.com">
                        <img src="../../assets/img/logo-dark.png" alt="">
                    </a>

                    <RegisterLink :variant="'white'"></RegisterLink>
                </div>
            </div>

            <div class="lamp">
            </div>
            <div class="text">Shattering Expectations in Iot</div>

            <div class="particles">
                <vue-particles  color="#17F9F9" linesColor="#16F8F8" :particlesNumber="100"></vue-particles>
            </div>
        </header>

        <div v-if="emailSent == false" class="contentpage">
            <div class="container-login">
                <h3>Reset password</h3>
                <h4>Type your email address, a link to reset your password will be send via email.</h4>

                <form class="fts-validation">
                    <fieldset :class="[(hasError) ? 'error-validation' : '']">
                        <label>
                            <i class="fa fa-envelope-o"></i>
                        </label>
                        <input type="text" name="ulogin" placeholder="Enter your email address" v-model="credential.userName">
                        <p class="validate-warning" v-if="hasError">This field is required</p>
                    </fieldset>

                    <fieldset :class="['recaptcha', (captchaError) ? 'error-validation' : '']">
                        <vue-recaptcha ref="recaptcha" @verify="verifyMethod" @expired="expiredMethod" sitekey="6LcqsQ8hAAAAACTgTWzvhWrGtGI61m3x3PLwq-9U" />
                        <span v-if="captchaError" class="validate-warning">Please fill the Captcha</span>
                    </fieldset>

                    <button type="submit" v-on:click.prevent="resetpsw" class="btn btn-sumbit">Send</button>
                </form>

                <router-link to="/login">Login into account</router-link>
            </div>
        </div>

        <div v-else class="contentpage">
            <div class="container-login">
                <h3>E-mail sent</h3>
                <h4>If {{credential.userName}} exists in our database we have sent you a reset password link. The link will be active for 30 minutes.</h4>
                <router-link to="/login">Login into account</router-link>
            </div>
        </div>

        <footer>
            <RegisterLink :content="'Don\'t have an account? Register'"></RegisterLink>
        </footer>
    </div>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import VueSession from "vue-session";
import VueCookies from "vue-cookies";
import globalStore from "../../variables";
import { error } from "util";
import VueParticles from 'vue-particles'
import { VueRecaptcha } from 'vue-recaptcha'
import RegisterLink from "@/views/RegisterLink";

Vue.use(VueParticles)
Vue.use(VueSession);
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

export default {
    name: "ForgotPassword",
    data() {
        return {
            visibleError: 0,
            credential: {
                userName: "",
                password: ""
            },
            hasError: false,
            emailSent: false,
			captchaToken: '',
			captchaError: false,
            captchaError2: false
        };
    },
    components: {
        VueRecaptcha,
        RegisterLink
    },
    mounted: function() {
        var timestamp = new Date().getTime();

        if (this.$cookies.get("token")) {
            this.$router.push("/dashboard");
        }
    },
    methods: {
		errorMethod(response) {
			this.captchaError2 = true;
		}, 
		renderMethod(response) {
			this.captchaToken = '';
		},
		verifyMethod(response) {
			this.captchaToken = response;
			this.captchaError2 = false;
			this.captchaError = false;
		},
		expiredMethod(response) {
			this.captchaToken = '';
			this.captchaError2 = true;
		},
        resetpsw() {
            if (this.credential.userName.length == 0) {
                this.hasError = true;
                return false;
            } else {
                this.hasError = false;
            }

            if (this.captchaToken == '') {
				this.captchaError = true;
				return false;
			} else {
				this.captchaError = false;
			}

            let emailToReset = {
                email: this.credential.userName 
            }

            Axios.post(`${globalStore.data.restApiUrl}/register/resetPassword?captchaToken=${this.captchaToken}`, emailToReset)
                .then(response => {
                    this.emailSent = true
                }).catch(error => {
                    if (error.response.data && error.response.data.errors && error.response.data.errors[0].errorMessage == 'Did not found user for passed username') {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'User not found',
                            text: 'There is no user registered with this e-mail address.',
                            duration: 5000,
                        });
                    } else if (error.response.data && error.response.data.errors && error.response.data.errors[0].errorMessage == 'must be a well-formed email address') {
                        this.$notify({
                            type: 'error',
                            group: 'notification',
                            title: 'Wrong e-mail address format',
                            text: 'Please, type correct e-mail address format.',
                            duration: 5000,
                        });
                    } else {
                        if (error.response.status != 429) {
                            this.$notify({
                                type: 'warn',
                                group: 'notification',
                                title: 'Reset password not working',
                                text: 'Error Resetting Password - Contact Support',
                                duration: 5000,
                            });
                        }
                    }
                })
                window.grecaptcha.reset();
                this.captchaToken = ''; 
        }
    }
};
</script>

<style lang="scss">

header.header-animation {
    position: relative;

    .top {
        position: absolute;
        padding: 20px 0;
        top: 0;
        left: 0;
        right: 0;

        .container {
            display: flex;
            justify-content: space-between;
			align-items: center;

            a {
                color: #fff;
                font: 400 15px/16px "Roboto", "Arial", sans-serif;
            }
        }
    }

    .lamp {
        position: absolute;
        height: 344px;
        width: 512px;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        top: 84px;
        background: transparent url("../../assets/img/lamp-login.png") no-repeat center center;
    }

    .text {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 213px;
        background: rgba(1, 24, 38, .84);
        text-align: center;
        font: 700 37px/43px "Roboto", "Arial", sans-serif;
        text-transform: uppercase;
        letter-spacing: 4px;
        color: #fff;
    }
}

.particles {
    background-color: #021927;
    height: 480px;
    overflow: hidden;
    #particles-js {
        height: 480px;
    }
}
.gradient-login {
    background: #00ff97; /* Old browsers */
    background: -moz-linear-gradient(45deg,  #00ff97 0%, #0055ff 99%); /* FF3.6-15 */
    background: -webkit-linear-gradient(45deg,  #00ff97 0%,#0055ff 99%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(45deg,  #00ff97 0%,#0055ff 99%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ff97', endColorstr='#0055ff',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
    background-color: #e4e5e6;
}

.contentpage {
    background-color: #F8F8F8;
    padding: 43px 0 90px;
    text-align: center;

    h3 {
        display: block;
        margin-bottom: 13px;
        font: 700 20px/26px "Roboto", "Arial", sans-serif;
        color: #000;
    }

    h4 {
        display: block;
        margin-bottom: 20px;
        font: 400 14px/19px "Roboto", "Arial", sans-serif;
        color: #9F9F9F;
    }

    form {
        fieldset {
            margin-bottom: 16px;
            label {
                display: inline-block;
                vertical-align: top;
                width: 40px;
                height: 35px;
                margin: 0;
                background-color: #fff;
                border-radius: 5px 0 0 5px ;
                border-width: 1px 0 1px 1px;
                border-style: solid;
                border-color: #E4E7EA;
                line-height: 35px;
            }
            input {
                display: inline-block;
                vertical-align: top;
                width: 262px;
                height: 35px;
                padding: 0 10px;
                background-color: #E4E5E6;
                border-radius: 0 5px 5px 0;
                border-width: 1px 1px 1px 1px;
                border-style: solid;
                border-color: #C9CFD4;
                line-height: 35px;
                outline: none !important;
                box-sizing: border-box;
            }
        }

        .btn-sumbit {
            height: 35px;
            padding: 0 25px;
            margin-bottom: 20px;
            background-color: #0088FF;
            border-radius: 5px;
            font: 400 14px/33px "Roboto", "Arial", sans-serif;
            color: #fff;
        }
    }

    a {
        font-size: 14px;
    }
}

.recaptcha {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.validate-warning {
    display: block;
    margin-top: 5px;
    color: #FC4D4D;
    font-size: 12px;
    transition: all .4s ease-in-out;
}

footer {
    padding: 25px 0 100px;
    text-align: center;
}
</style>
